export default __webpack_public_path__ + "static/media/logout.63f10066.svg";